// --- 2. Quiz Generators ---
function generateDynamicQuestion() {
  const questionTypes = ["Counting", "Addition", "Subtraction", "More or Less", "Simple Shapes"];
  const type = questionTypes[Math.floor(Math.random() * questionTypes.length)];
  let question = {};

  switch (type) {
    case "Counting": {
      const countFrom = Math.floor(Math.random() * 10) + 1;
      question.question = `What number comes after ${countFrom}?`;
      question.correctAnswer = countFrom + 1;
      question.options = [countFrom, countFrom + 1, countFrom + 2].sort(() => 0.5 - Math.random());
      break;
    }
    case "Addition": {
      const add1 = Math.floor(Math.random() * 10) + 1;
      const add2 = Math.floor(Math.random() * 10) + 1;
      question.question = `${add1} + ${add2} = ?`;
      question.correctAnswer = add1 + add2;
      question.options = [add1 + add2, add1 + add2 + 1, add1 + add2 - 1].sort(() => 0.5 - Math.random());
      break;
    }
    case "Subtraction": {
      let sub1 = Math.floor(Math.random() * 10) + 1;
      let sub2 = Math.floor(Math.random() * sub1) + 1;
      question.question = `${sub1} - ${sub2} = ?`;
      question.correctAnswer = sub1 - sub2;
      question.options = [
        sub1 - sub2,
        sub1 - sub2 + 1,
        Math.max(0, sub1 - sub2 - 1),
      ].sort(() => 0.5 - Math.random());
      break;
    }
    case "More or Less": {
      let number1 = Math.floor(Math.random() * 10) + 1;
      let number2;
      do {
        number2 = Math.floor(Math.random() * 10) + 1;
      } while (number2 === number1);

      question.question = `Which is more, ${number1} or ${number2}?`;
      question.correctAnswer = number1 > number2 ? number1 : number2;
      const wrongOption = number1 < number2 ? number1 : number2;
      question.options = [question.correctAnswer, wrongOption, question.correctAnswer + 1].sort(
        () => 0.5 - Math.random()
      );
      break;
    }
    case "Simple Shapes": {
      const shapes = ["🔺 Triangle", "🟦 Square", "⚫ Circle", "🔶 Diamond"];
      const correctShape = shapes[Math.floor(Math.random() * shapes.length)];
      question.question = `Which shape is this: ${correctShape.split(" ")[0]}?`;
      question.correctAnswer = correctShape.split(" ")[1];
      question.options = shapes.map((s) => s.split(" ")[1]).sort(() => 0.5 - Math.random());
      break;
    }
    default:
      break;
  }
  return question;
}

export function generateQuizQuestions(count = 10) {
  return Array.from({ length: count }, generateDynamicQuestion);
}

export function generateFinalQuizQuestions(count = 50) {
  const questions = [];
  const usedSet = new Set();
  while (questions.length < count) {
    let type = ["counting", "addition", "subtraction"][Math.floor(Math.random() * 3)];
    let num1 = Math.floor(Math.random() * 10) + 1;
    let num2 = Math.floor(Math.random() * 10) + 1;
    let key = `${type}-${num1}-${num2}`;
    if (usedSet.has(key)) continue;
    usedSet.add(key);
    let questionStr = "";
    let correctAnswer;
    let options;
    if (type === "counting") {
      questionStr = `What comes after ${num1}?`;
      correctAnswer = num1 + 1;
      options = [correctAnswer, correctAnswer + 1, Math.max(0, correctAnswer - 1)];
    } else if (type === "addition") {
      questionStr = `${num1} + ${num2} = ?`;
      correctAnswer = num1 + num2;
      options = [correctAnswer, correctAnswer + 1, correctAnswer - 1];
    } else {
      let bigger = Math.max(num1, num2);
      let smaller = Math.min(num1, num2);
      questionStr = `${bigger} - ${smaller} = ?`;
      correctAnswer = bigger - smaller;
      options = [correctAnswer, correctAnswer + 1, Math.max(0, correctAnswer - 1)];
    }
    options.sort(() => Math.random() - 0.5);
    questions.push({ question: questionStr, correctAnswer, options });
  }
  return questions;
}